// extracted by mini-css-extract-plugin
module.exports = {"root":"style__root--3KDax","header":"style__header--3y_vv","row1":"style__row1--3UIWf","row2":"style__row2--2pC0_","btn":"style__btn--3MMWP","hr":"style__hr--1Ntir"};
    if(module.hot) {
      // 1645651744817
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
    }
  